import React, { useEffect } from 'react';
import BaseForm from 'components/atoms/base-form';
import BaseFormItem from 'components/atoms/base-form/item';
import { useFormik } from 'formik';
import { useTranslation } from 'react-i18next';
import BaseDatepicker from 'components/atoms/base-datepicker';
import BaseModal from 'components/atoms/base-modal';
import BaseButton from 'components/atoms/baseButton';
import { useUpdateConsentDate } from 'infrastructure/hooks/patient/use-update-consent-date';
import {
  commonValidationSchemas,
  createValidationSchema,
} from 'infrastructure/functions';

interface IConsentDateUpdateProps {
  patientGuid: string;
  consentDate?: Date | null;
  opened: boolean;
  onCancel: () => void;
}

const ConsentDateUpdate: React.FC<IConsentDateUpdateProps> = (props) => {
  const { patientGuid, consentDate, opened, onCancel } = props;

  const { t } = useTranslation();

  const { update, loading } = useUpdateConsentDate();

  const formik = useFormik({
    initialValues: { consentDate },
    onSubmit: async (values) => {
      if (values.consentDate) {
        await update(patientGuid, new Date(values.consentDate));
        onCancel();
      }
    },
    validateOnChange: false,
    validationSchema: createValidationSchema({
      consentDate: commonValidationSchemas.date().required(),
    }),
  });

  useEffect(() => {
    formik.resetForm({ values: { consentDate } });
  }, [consentDate]);

  return (
    <BaseModal
      open={opened}
      title={t('labels.ccmConsentDate')}
      onCancel={onCancel}
      withFooter={[
        <BaseButton
          dataCy="form-save-button"
          label={t('controls.save')}
          onClick={formik.submitForm}
          loading={loading}
          disabled={loading}
        />,
        <BaseButton
          type="secondary"
          dataCy="form-cancel-button"
          label={t('controls.cancel')}
          onClick={onCancel}
          loading={loading}
          disabled={loading}
        />,
      ]}
    >
      <BaseForm formik={formik}>
        <BaseFormItem name="consentDate">
          <BaseDatepicker allowClear maxDate={new Date()} />
        </BaseFormItem>
      </BaseForm>
    </BaseModal>
  );
};

export default ConsentDateUpdate;
